import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";

type Props = {
  data: any;
  type: "column" | "news";
};

export const Archive = (props: Props) => {
  const [years, setYears] = useState<string[]>([]);
  useEffect(() => {
    const years: string[] = [];
    if (!props.data) return;
    props.data.forEach((data: any) => {
      const year = dayjs(data.date).format("YYYY");
      if (!years.includes(year)) {
        years.push(year);
      }
    });
    setYears(years);
  }, [props.data]);

  return (
    <section className="archive">
      <h3>アーカイブ</h3>
      <ul>
        {years.map((year, index) => {
          return (
            <li key={index} className="archive-item">
              <p className="year">{year}年</p>
              <ul className="archive-list">
                {props.data.map((data: any, idx: number) => {
                  if (dayjs(data.date).format("YYYY") === year) {
                    return (
                      <li key={idx} className="archive-list_title">
                        <Link to={`/${props.type}/${data.id}`}>
                          {data.title.rendered}
                        </Link>
                      </li>
                    );
                  }
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    </section>
  );
};
